import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type CompletionSettingsFragment = { considerRecordingProgress?: boolean | null, requirePreWorkPostWork: boolean, recurringSessionCompletionRollupType?: Types.RecurringSessionCompletionRollupTypeEnum | null, attendanceRecordingCompletionThreshold?: number | null, attendanceRecordingAbsentThreshold?: number | null };


export type CompletionSettingsFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const CompletionSettingsFragmentDoc = /*#__PURE__*/ gql`
    fragment CompletionSettings on CompletionSettingsType {
  considerRecordingProgress
  requirePreWorkPostWork
  recurringSessionCompletionRollupType
  attendanceRecordingCompletionThreshold
  attendanceRecordingAbsentThreshold
}
    `;